import React from 'react';

/** True after the first download/send reserved this document number (GoBD issued). */
export const OfferDocumentIssuedContext = React.createContext(false);

export function useOfferDocumentIssued(): boolean {
  return React.useContext(OfferDocumentIssuedContext);
}
